// Dividends State

export default {
  dividendsList: [],
  dividendInfo: {},
  incomeAfterTax: {}
}
